var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.5C10.3547 6.5 8.87737 7.22227 7.86883 8.36881L9.07322 9.5732C9.23071 9.73069 9.11917 9.99998 8.89645 9.99998H5.25C5.11193 9.99998 5 9.88805 5 9.74998V6.10353C5 5.8808 5.26929 5.76926 5.42678 5.92675L6.8066 7.30658C8.08696 5.89075 9.93912 5 12 5C15.5822 5 18.5351 7.69021 18.9501 11.1609C18.9993 11.5722 18.7058 11.9455 18.2945 11.9947C17.8832 12.0439 17.5099 11.7503 17.4607 11.3391C17.1348 8.61345 14.8136 6.5 12 6.5ZM5.70545 12.0053C6.11673 11.9561 6.49001 12.2497 6.5392 12.6609C6.86516 15.3865 9.18631 17.5 12 17.5C13.6453 17.5 15.1226 16.7777 16.1311 15.6312L14.9268 14.4268C14.7693 14.2693 14.8808 14 15.1036 14H18.75C18.8881 14 19 14.112 19 14.25V17.8965C19 18.1192 18.7307 18.2307 18.5732 18.0732L17.1934 16.6934C15.913 18.1092 14.0608 19 12 19C8.41771 19 5.46489 16.3098 5.04981 12.8391C5.00063 12.4278 5.29417 12.0545 5.70545 12.0053Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentRefresh);
export default __webpack_public_path__ + "static/media/appointment-refresh.9e5833e6c389cdedcba965677c418956.svg";
export { ForwardRef as ReactComponent };